const showImage = {
    borderRadius: {
        basic: '4px',
        topRound: '12px 12px 0 0',
        none: '0',
    },
};
export default showImage;
//# sourceMappingURL=showImage.js.map